import { api } from "@/config/api";
import type { AxiosError } from "axios";
import { PassesFailReason, ValidPassesFailReason } from "ipctg-inflow-types/InFlowEnums";
import type {
  ParkPassesPOSTErrorResponse,
  ParkPassesPOSTRequest,
  ParkPassesPOSTSuccessResponse,
  ParkValidPassesPOSTErrorResponse,
  ParkValidPassesPOSTRequest,
  ParkValidPassesPOSTSuccessResponse,
} from "ipctg-inflow-types/InFlowParkAPI";

export const fetchPasses = async (requestData: ParkPassesPOSTRequest): Promise<ParkPassesPOSTSuccessResponse["passes"]> => {
  try {
    const response = await api.post<ParkPassesPOSTSuccessResponse>("/passes", requestData);
    return response.data.passes;
  } catch (error) {
    const axiosError = error as AxiosError<ParkPassesPOSTErrorResponse>;
    throw axiosError.response?.data ?? { failReason: PassesFailReason };
  }
};

export const fetchValidPassesData = async (requestData: ParkValidPassesPOSTRequest): Promise<ParkValidPassesPOSTSuccessResponse> => {
  try {
    const response = await api.post("/valid-passes", requestData);
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError<ParkValidPassesPOSTErrorResponse>;
    throw axiosError.response?.data ?? { failReason: ValidPassesFailReason };
  }
};
